import { createSelector } from '@reduxjs/toolkit';
import { campaignsSelectors } from '../campaignsSelectors';
export var getCampaignHealthStatus = createSelector([
    campaignsSelectors.selectById
], function(campaign) {
    return campaign === null || campaign === void 0 ? void 0 : campaign.healthStatus;
});
